import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/outdated.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm outdated [<package-spec> ...]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/outdated.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`This command will check the registry to see if any (or, specific) installed
packages are currently outdated.`}</p>
    <p>{`By default, only the direct dependencies of the root project and direct
dependencies of your configured `}<em parentName="p">{`workspaces`}</em>{` are shown.
Use `}<inlineCode parentName="p">{`--all`}</inlineCode>{` to find all outdated meta-dependencies as well.`}</p>
    <p>{`In the output:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`wanted`}</inlineCode>{` is the maximum version of the package that satisfies the semver
range specified in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`. If there's no available semver range
(i.e.  you're running `}<inlineCode parentName="li">{`npm outdated --global`}</inlineCode>{`, or the package isn't
included in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`), then `}<inlineCode parentName="li">{`wanted`}</inlineCode>{` shows the currently-installed
version.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`latest`}</inlineCode>{` is the version of the package tagged as latest in the registry.
Running `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{` with no special configuration will publish the
package with a dist-tag of `}<inlineCode parentName="li">{`latest`}</inlineCode>{`. This may or may not be the maximum
version of the package, or the most-recently published version of the
package, depending on how the package's developer manages the latest
`}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}>{`dist-tag`}</a>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`location`}</inlineCode>{` is where in the physical tree the package is located.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`depended by`}</inlineCode>{` shows which package depends on the displayed dependency`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`package type`}</inlineCode>{` (when using `}<inlineCode parentName="li">{`--long`}</inlineCode>{` / `}<inlineCode parentName="li">{`-l`}</inlineCode>{`) tells you whether this
package is a `}<inlineCode parentName="li">{`dependency`}</inlineCode>{` or a dev/peer/optional dependency. Packages not
included in `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` are always marked `}<inlineCode parentName="li">{`dependencies`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`homepage`}</inlineCode>{` (when using `}<inlineCode parentName="li">{`--long`}</inlineCode>{` / `}<inlineCode parentName="li">{`-l`}</inlineCode>{`) is the `}<inlineCode parentName="li">{`homepage`}</inlineCode>{` value contained
in the package's packument`}</li>
      <li parentName="ul">{`Red means there's a newer version matching your semver requirements, so
you should update now.`}</li>
      <li parentName="ul">{`Yellow indicates that there's a newer version `}<em parentName="li">{`above`}</em>{` your semver
requirements (usually new major, or new 0.x minor) so proceed with
caution.`}</li>
    </ul>
    <h3>{`An example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm outdated
Package      Current   Wanted   Latest  Location                  Depended by
glob          5.0.15   5.0.15    6.0.1  node_modules/glob         dependent-package-name
nothingness    0.0.3      git      git  node_modules/nothingness  dependent-package-name
npm            3.5.1    3.5.2    3.5.1  node_modules/npm          dependent-package-name
local-dev      0.0.3   linked   linked  local-dev                 dependent-package-name
once           1.3.2    1.3.3    1.3.3  node_modules/once         dependent-package-name
`}</code></pre>
    <p>{`With these `}<inlineCode parentName="p">{`dependencies`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "glob": "^5.0.15",
  "nothingness": "github:othiym23/nothingness#master",
  "npm": "^3.5.1",
  "once": "^1.3.1"
}
`}</code></pre>
    <p>{`A few things to note:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`glob`}</inlineCode>{` requires `}<inlineCode parentName="li">{`^5`}</inlineCode>{`, which prevents npm from installing `}<inlineCode parentName="li">{`glob@6`}</inlineCode>{`, which
is outside the semver range.`}</li>
      <li parentName="ul">{`Git dependencies will always be reinstalled, because of how they're
specified.  The installed committish might satisfy the dependency
specifier (if it's something immutable, like a commit SHA), or it might
not, so `}<inlineCode parentName="li">{`npm outdated`}</inlineCode>{` and `}<inlineCode parentName="li">{`npm update`}</inlineCode>{` have to fetch Git repos to check.
This is why currently doing a reinstall of a Git dependency always forces
a new clone and install.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`npm@3.5.2`}</inlineCode>{` is marked as "wanted", but "latest" is `}<inlineCode parentName="li">{`npm@3.5.1`}</inlineCode>{` because
npm uses dist-tags to manage its `}<inlineCode parentName="li">{`latest`}</inlineCode>{` and `}<inlineCode parentName="li">{`next`}</inlineCode>{` release channels.
`}<inlineCode parentName="li">{`npm update`}</inlineCode>{` will install the `}<em parentName="li">{`newest`}</em>{` version, but `}<inlineCode parentName="li">{`npm install npm`}</inlineCode>{`
(with no semver range) will install whatever's tagged as `}<inlineCode parentName="li">{`latest`}</inlineCode>{`.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`once`}</inlineCode>{` is just plain out of date. Reinstalling `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` from
scratch or running `}<inlineCode parentName="li">{`npm update`}</inlineCode>{` will bring it up to spec.`}</li>
    </ul>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`all`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When running `}<inlineCode parentName="p">{`npm outdated`}</inlineCode>{` and `}<inlineCode parentName="p">{`npm ls`}</inlineCode>{`, setting `}<inlineCode parentName="p">{`--all`}</inlineCode>{` will show all
outdated or installed packages, rather than only those directly depended
upon by the current project.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`long`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Show extended information in `}<inlineCode parentName="p">{`ls`}</inlineCode>{`, `}<inlineCode parentName="p">{`search`}</inlineCode>{`, and `}<inlineCode parentName="p">{`help-search`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`parseable`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Output parseable results from commands that write to standard output. For
`}<inlineCode parentName="p">{`npm search`}</inlineCode>{`, this will be tab-separated table format.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`global`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Operates in "global" mode, so that packages are installed into the `}<inlineCode parentName="p">{`prefix`}</inlineCode>{`
folder instead of the current working directory. See
`}<a parentName="p" {...{
        "href": "/cli/v8/configuring-npm/folders"
      }}>{`folders`}</a>{` for more on the differences in behavior.`}</p>
    <ul>
      <li parentName="ul">{`packages are installed into the `}<inlineCode parentName="li">{`{prefix}/lib/node_modules`}</inlineCode>{` folder, instead
of the current working directory.`}</li>
      <li parentName="ul">{`bin files are linked to `}<inlineCode parentName="li">{`{prefix}/bin`}</inlineCode></li>
      <li parentName="ul">{`man pages are linked to `}<inlineCode parentName="li">{`{prefix}/share/man`}</inlineCode></li>
    </ul>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/package-spec"
        }}>{`package spec`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-update"
        }}>{`npm update`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-dist-tag"
        }}>{`npm dist-tag`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/registry"
        }}>{`npm registry`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/configuring-npm/folders"
        }}>{`npm folders`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/workspaces"
        }}>{`npm workspaces`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      